class appointmenFinderController {
	constructor(appointmentFinderService, cfpLoadingBar) {
		this.appointmentFinderService = appointmentFinderService;
		this.cfpLoadingBar = cfpLoadingBar;
	}
	$onInit() {
		// Defaults values
		this.carrierList = [];
		this.planList = [];
		this.addressList = [];
		this.doctorList = [];
		this.doctorOrConditionList = [];
		this.doctorListFilter = {
			problem: [],
			languages: [],
			sortFields: [],
		};
		this.selectedPage = 1;
		this.elementsForPage = 5;
		this.language = this.language || 'en';

		// Update values
		this.getCarriers();
		this.getPlans();
		this.getAddress();
		this.getDoctorList();
		this.getDoctorFilter();
		this.getDoctorOrConditionList();
	}
	getCarriers() {
		this.appointmentFinderService.getCarriers(this.language)
			.then(carriers => {
				this.carrierList = carriers;
			}).catch(() => {
				// console.log('Inespected error', error);				
			});
	}
	getPlans() {
		this.appointmentFinderService.getPlans(this.language).then(plans => {
			this.planList = plans;
		}).catch(() => {
			// console.log('Inespected error', error);			
		});
	}
	getAddress() {
		this.appointmentFinderService.getAddress(this.language).then(address => {
			this.addressList = address;
		}).catch(() => {
			// console.log('Inespected error', error);			
		});
	}
	getDoctorList() {
		this.cfpLoadingBar.start();
		this.appointmentFinderService.getDoctorList(this.language).then(doctorList => {
			this.doctorList = doctorList;
			this.cfpLoadingBar.complete();
		}).catch(() => {
			this.cfpLoadingBar.complete();
			// console.log('Inespected error', error);			
		});
	}
	getDoctorFilter() {
		this.appointmentFinderService.getDoctorFilter(this.language).then(doctorListFilter => {
			this.doctorListFilter = doctorListFilter;
		}).catch(() => {
			// console.log('Inespected error', error);			
		});
	}
	getDoctorOrConditionList() {
		this.cfpLoadingBar.start();
		this.appointmentFinderService.getDoctorOrConditionList(this.language).then(doctorOrConditionList => {
			this.doctorOrConditionList = doctorOrConditionList;
			this.cfpLoadingBar.complete();
		}).catch(() => {
			this.cfpLoadingBar.complete();
		})
	}

	onSearch({
		selectedPlan,
		selectedAddress,
		selectedDoctor
	}) {
		this.cfpLoadingBar.start();
		const filterParameters = {
			selectedPlan,
			selectedAddress,
			selectedDoctor
		};
		this.appointmentFinderService.filter(filterParameters).then(doctorListFiltered => {
			this.doctorList = doctorListFiltered;
			this.cfpLoadingBar.complete();
		}).catch(() => {
			this.cfpLoadingBar.complete();
			// console.log('Inespected error', error);
		});
	}

	isLoading() {
		this.isLoading = (this.carrierList && this.planList && this.addressList && this.doctorList && this.doctorListFilter) ? false : true;
	}

}
appointmenFinderController.$inject = ['appointmentFinderService', 'cfpLoadingBar'];

export default appointmenFinderController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/appointment-finder/appointment-finder.controller.js